import React from "react";
import { Route, Routes } from "react-router-dom";
import Layout from "./layout/Layout";
import "./App.css"

/**
 * Defines the root application component.
 * @returns {JSX.Element}
 */
function App() {
  return (
    <Routes>
      <Route path="*" element={<Layout />} />
    </Routes>
  );
}

export default App;